import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

const CoursewareLoginLink = () => {
  const loginURL = useSelector(state => state.asset.onlineResource.loginURL)

  return (
    <div className='u-push--top'>
      <h2 className='styled_as_h3'>
        {translate('common.courseware_website')}
      </h2>
      <a
        className='link--branded'
        data-testid='Login Link'
        href={loginURL}
      >
        {loginURL}
      </a>
    </div>
  )
}

export default CoursewareLoginLink
